module.exports = __webpack_public_path__ + "media/images/icons/meta-77b2cd90193c4d686a3b8379f8c50e93.svg";